import React, { useState, useEffect } from "react";

export const useDPIScreenCheck = () => {
  const [isHighDPI, setIsHighDPI] = useState(false);

  useEffect(() => {
    const checkDPI = () => {
      if (window) {
        setIsHighDPI(window.devicePixelRatio > 1);
      }
    };

    checkDPI();
  }, []);

  return isHighDPI;
};
